import { useCallback, useState } from "react";
import { Link } from "react-router-dom";

export default function MenuBar({ isOpen, setIsOpen }) {
  const [activeMenu, setActiveMenu] = useState(null);

  const handleMenuClick = useCallback(
    (menu) => { setActiveMenu((prevMenu) => (prevMenu === menu ? null : menu)); },
    []
  );
  
  const handleLinkClick = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <>
      {isOpen ? <div className="overlay-menubar"></div> : null}
      <section
        className={
          isOpen ? "menubar-area open-menu" : "menubar-area close-menu"
        }
      >
        <div className="menu-header">
          <div className="menu-close-btn">
            <span onClick={() => setIsOpen(!isOpen)}>✕</span>
          </div>
        </div>

        <ul className="menu-toggel-items">
          <li onClick={() => handleMenuClick("Company")}>
            Company <label>{activeMenu === "Company" ? "−" : "+"}</label>
            <ul
              className={
                activeMenu === "Company" ? "submenu visible" : "submenu"
              }
            >
              <li>
                <Link to="/about" onClick={handleLinkClick}>
                  About Us
                </Link>
              </li>
              {/* <li>
                <Link to="/awards" onClick={handleLinkClick}>
                  Awards
                </Link>
              </li> */}
              {/* <li>
                <Link to="/careers" onClick={handleLinkClick}>
                  Careers
                </Link>
              </li> */}
            </ul>
          </li>

          <li onClick={() => handleMenuClick("Solutions")}>
            Solutions <label>{activeMenu === "Solutions" ? "−" : "+"}</label>
            <ul className={ activeMenu === "Solutions" ? "submenu visible" : "submenu"}>
              <li>
                <Link to="/best-taxi-dispatch-software" onClick={handleLinkClick}>
                  Taxi Dispatch Software
                </Link>
              </li>

              <li>
                <Link to="/car-rental-software" onClick={handleLinkClick}>
                  Car Rental Software
                </Link>
              </li>

              <li>
                <Link to="/white-lable-carpool-app-dispatch-software" onClick={handleLinkClick}>
                  Carpool & rideshare software
                </Link>
              </li>
              <li>
                <Link to="/shuttle-software" onClick={handleLinkClick}>
                  Shuttle Software
                </Link>
              </li>

              <li>
                <Link to="/white-label-solutions" onClick={handleLinkClick}>
                  White Label Solutions
                </Link>
              </li>

              <li>
                <Link to="/bike-rental" onClick={handleLinkClick}>
                 Bike Rental Software
                </Link>
              </li>

              <li>
                <Link to="/airport-transfer-software" onClick={handleLinkClick}>
                 airport transfer software
                </Link>
              </li>

              <li>
                <Link to="/custom-app-development" onClick={handleLinkClick}>
                 custom app development
                </Link>
              </li>

              <li>
                <Link to="/web-app-development" onClick={handleLinkClick}>
                 web app development
                </Link>
              </li>
            </ul>
          </li>

          <li onClick={() => handleMenuClick("Industries")}>
            Industries <label>{activeMenu === "Industries" ? "−" : "+"}</label>
            <ul
              className={
                activeMenu === "Industries" ? "submenu visible" : "submenu"
              }
            >
              <li>
                <Link to="/best-logistic-app-development-company" onClick={handleLinkClick}>
                Logistic and transportation
                </Link>
              </li>

              <li>
                <Link to="/custom-healthcare-app-development-services" onClick={handleLinkClick}>
                Healthcare
                </Link>
              </li>

              <li>
                <Link to="/food-grocery-delivery-app-development-company" onClick={handleLinkClick}>
                food & grocery
                </Link>
              </li>

              <li>
                <Link to="/best-pharmacy-app-development-company" onClick={handleLinkClick}>
                Pharmacy
                </Link>
              </li>

              <li>
                <Link to="/ecommerce-mobile-app-development-company" onClick={handleLinkClick}>
                E-Commerce
                </Link>
              </li>
              
              <li>
                <Link to="/education-app-development-services" onClick={handleLinkClick}>
                education
                </Link>
              </li>

              <li>
                <Link to="/telemedicine-app-development-company" onClick={handleLinkClick}>
                telemedicine
                </Link>
              </li>

              <li>
                <Link to="/restaurant-app-development-company" onClick={handleLinkClick}>
                restaurant
                </Link>
              </li>
            </ul>
          </li>

          <li onClick={() => handleMenuClick("cloneApps")}>
            Clone Apps <label>{activeMenu === "cloneApps" ? "−" : "+"}</label>
            <ul className={activeMenu === "cloneApps" ? "submenu visible" : "submenu"}>
              <li><Link to="/clone-app/lyft-clone-app" onClick={handleLinkClick}>Lyft clone</Link></li>
              <li><Link to="/clone-app/uber-clone-app" onClick={handleLinkClick}>Uber clone</Link></li>
              <li><Link to="/clone-app/zipcar-clone-app" onClick={handleLinkClick}>Zipcar clone</Link></li>
              <li><Link to="/clone-app/cabify-clone-app" onClick={handleLinkClick}>Cabify clone</Link></li>
              <li><Link to="/clone-app/bolt-clone-app" onClick={handleLinkClick}>Bolt clone</Link></li>
              <li><Link to="/clone-app/mai-linh-clone-app" onClick={handleLinkClick}>mai linh clone</Link></li>
              <li><Link to="/clone-app/xanh-sm-clone-app" onClick={handleLinkClick}>xanh sm clone</Link></li>
              <li><Link to="/clone-app/yellow-cab-clone-app" onClick={handleLinkClick}>yellow cab clone</Link></li>
              <li><Link to="/clone-app/uride-clone-app" onClick={handleLinkClick}>uride clone</Link></li>
              <li><Link to="/clone-app/easy-taxi-clone-app" onClick={handleLinkClick}>easy taxi clone</Link></li>
              <li><Link to="/clone-app/zoom-zoom-clone-app" onClick={handleLinkClick}>zoom zoom clone</Link></li>
              <li><Link to="/clone-app/va-de-taxi-clone-app" onClick={handleLinkClick}>Vá de Táxi clone</Link></li>
              <li><Link to="/clone-app/free-now-clone-app" onClick={handleLinkClick}>free now clone</Link></li>
              <li><Link to="/clone-app/99taxis-clone-app" onClick={handleLinkClick}>99taxis clone</Link></li>
              <li><Link to="/clone-app/blabla-car-clone-app" onClick={handleLinkClick}>blabla car clone</Link></li>
              <li><Link to="/clone-app/blabla-car-clone-app-italy" onClick={handleLinkClick}>blabla car clone italy</Link></li>
              <li><Link to="/clone-app/grab-clone-app" onClick={handleLinkClick}>grab clone</Link></li>
            </ul>
          </li>

          <li onClick={() => handleMenuClick("Resources")}>
            Resource <label>{activeMenu === "Resources" ? "−" : "+"}</label>
            <ul
              className={
                activeMenu === "Resources" ? "submenu visible" : "submenu"
              }
            >
              {/* <li>
                <Link to="/news" onClick={handleLinkClick}>
                  News
                </Link>
              </li> */}
              {/* <li>
                <Link to="/case-study" onClick={handleLinkClick}>
                  Case Studies
                </Link>
              </li> */}
              <li>
                <Link to="/blog" onClick={handleLinkClick}>
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/case-study" onClick={handleLinkClick}>
                  Case Study
                </Link>
              </li>
              <li>
                <Link to="/media" onClick={handleLinkClick}>
                  Media
                </Link>
              </li>
            </ul>
          </li>

          <li onClick={() => handleMenuClick("Features")}>
            Features <label>{activeMenu === "Features" ? "−" : "+"}</label>
            <ul
              className={
                activeMenu === "Features" ? "submenu visible" : "submenu"
              }
            >
              <li>
                <Link to="/features/taxi-software" onClick={handleLinkClick}>
                  Taxi Software
                </Link>
              </li>
            </ul>
          </li>

          <li>
            <Link to={"/pricing"} onClick={handleLinkClick}>Pricing</Link>
          </li>
          
          <li>
            <Link to="/contact" onClick={handleLinkClick}>
              Contact Us
            </Link>
          </li>
        </ul>

        <div className="menu-footer">
          <span>LET’S GET STARTED</span>
          <p>We love technology but not as much as being Human.</p>
          <Link to="/contact" className="default-btn" onClick={handleLinkClick}>
            WORK WITH US
          </Link>
        </div>
      </section>
    </>
  );
}
